"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCustomer = exports.CustomerProvider = exports.CustomerContext = void 0;
var React = require("react");
var react_1 = require("react");
exports.CustomerContext = (0, react_1.createContext)({
    setNewCustomer: function () { return undefined; },
    newCustomer: { name: '', uuid: '' }
});
var CustomerProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(null), newCustomer = _b[0], setNewCustomer = _b[1];
    return (React.createElement(exports.CustomerContext.Provider, { value: { newCustomer: newCustomer, setNewCustomer: setNewCustomer } }, children));
};
exports.CustomerProvider = CustomerProvider;
var useCustomer = function () {
    return (0, react_1.useContext)(exports.CustomerContext);
};
exports.useCustomer = useCustomer;
